import React, { FC, useContext } from 'react';
import get from 'lodash/get';

import FormContext from 'src/presentation/contexts/FormContext';
import InputField from 'src/presentation/components/forms/InputField';
import NodeSelector from '../NodeSelector';
import {
  Content,
  Footer,
  Row,
  ScrollRow,
  StyledTextarea,
} from 'src/presentation/components/pages/ivr/layouts/IvrLayout';
import { EXPRESSION_DESCRIPTION } from 'src/presentation/components/pages/ivr/components/nodes/VariableMatchNode';
import {
  NodeProps,
  SIDE_PANEL_ROW_TYPES,
  DESCRIPTION_PLACEHOLDER_TEXT,
  DESCRIPTION_LABEL_TEXT,
} from 'src/presentation/components/pages/ivr/constants/ivrConstants';

const VariableNode: FC<NodeProps> = ({ attr, disabled, onSelectNode, nodeList, readOnly, selectedOptionIndex }) => {
  const { workingState } = useContext(FormContext);
  const currentNodeId = get(workingState, `${attr}.id`);

  return (
    <>
      <Content>
        <Row>
          <InputField
            attr={`${attr}.name`}
            data-aid={`${attr}-name`}
            description="The name you can refer to link to other nodes"
            disabled={disabled}
            label="Name"
            readOnly={readOnly}
          />
        </Row>

        <Row>
          <InputField
            attr={`${attr}.description`}
            data-aid={`${attr}-description`}
            disabled={disabled}
            label={DESCRIPTION_LABEL_TEXT}
            placeholder={DESCRIPTION_PLACEHOLDER_TEXT}
            readOnly={readOnly}
          />
        </Row>

        <Row>
          <StyledTextarea
            attr={`${attr}.expression`}
            data-aid={`${attr}.expression`}
            description={EXPRESSION_DESCRIPTION}
            disabled={disabled}
            label="Expression"
            readOnly={readOnly}
          />
        </Row>
      </Content>

      <Footer>
        <ScrollRow scrollToIndex={selectedOptionIndex} type={SIDE_PANEL_ROW_TYPES.NOT_MATCH_ROW}>
          <NodeSelector
            attr={`${attr}.nextId`}
            data-aid={`${attr}.nextId`}
            description="The next node in the IVR"
            disabled={disabled}
            label="Next Node"
            omittedNodeIds={[currentNodeId]}
            onSelectNode={onSelectNode}
            options={nodeList}
            readOnly={readOnly}
            searchable
          />
        </ScrollRow>
        <ScrollRow scrollToIndex={selectedOptionIndex} type={SIDE_PANEL_ROW_TYPES.ERROR_ROW}>
          <NodeSelector
            attr={`${attr}.errorNodeId`}
            data-aid={`${attr}.errorNodeId`}
            description="Next IVR node if an error occurs evaluating the expression template definition"
            disabled={disabled}
            label="Error Node"
            omittedNodeIds={[currentNodeId]}
            onSelectNode={onSelectNode}
            options={nodeList}
            readOnly={readOnly}
            searchable
          />
        </ScrollRow>
      </Footer>
    </>
  );
};

export default VariableNode;
